<template>
    <div id="app">
        <Header></Header>
        <router-view></router-view>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from "./components/Header";
    import Footer from "./components/Footer";

    export default {
        name: 'App',
        components: {
            Header,
            Footer
        }
    }
</script>

<style>

    #app {
        width: 100%;
        background-color: #EAEAEA;
    }

    .vue-simple-drawer {
        backdrop-filter: blur(10px);
        background: #363636 !important;
        width: 50%;
        height: 100%;
    }

    .vue-simple-drawer .close-btn .leftright, .vue-simple-drawer .close-btn .rightleft {
        background-color: #EAEAEA !important;
    }

    a {
        color: #EAEAEA;
        margin-bottom: 1rem;
    }

    .progress {
        background-color: #ffffff;
        border-radius: 0;
    }

    .progress-bar {
        background-color: #A52A2A;
    }

    .card_body {
        margin-left: 20px;
        margin-right: 20px;
    }

    .md-form > .prefix {
        left: 1px;
    }

    .md-form .prefix.active {
        color: #A52A2A;
    }

    .md-form input:not([type]):focus:not([readonly]), .md-form input[type="text"]:not(.browser-default):focus:not([readonly]), .md-form input[type="password"]:not(.browser-default):focus:not([readonly]), .md-form input[type="email"]:not(.browser-default):focus:not([readonly]), .md-form input[type="url"]:not(.browser-default):focus:not([readonly]), .md-form input[type="time"]:not(.browser-default):focus:not([readonly]), .md-form input[type="date"]:not(.browser-default):focus:not([readonly]), .md-form input[type="datetime"]:not(.browser-default):focus:not([readonly]), .md-form input[type="datetime-local"]:not(.browser-default):focus:not([readonly]), .md-form input[type="tel"]:not(.browser-default):focus:not([readonly]), .md-form input[type="number"]:not(.browser-default):focus:not([readonly]), .md-form input[type="search"]:not(.browser-default):focus:not([readonly]), .md-form input[type="phone"]:not(.browser-default):focus:not([readonly]), .md-form input[type="search-md"]:focus:not([readonly]), .md-form textarea.md-textarea:focus:not([readonly]) {
        border-bottom: 1px solid #A52A2A;
        -webkit-box-shadow: 0 1px 0 0 #A52A2A;
        box-shadow: 0 1px 0 0 #A52A2A;
    }

    .md-form input:not([type]):focus:not([readonly])+label, .md-form input[type="text"]:not(.browser-default):focus:not([readonly])+label, .md-form input[type="password"]:not(.browser-default):focus:not([readonly])+label, .md-form input[type="email"]:not(.browser-default):focus:not([readonly])+label, .md-form input[type="url"]:not(.browser-default):focus:not([readonly])+label, .md-form input[type="time"]:not(.browser-default):focus:not([readonly])+label, .md-form input[type="date"]:not(.browser-default):focus:not([readonly])+label, .md-form input[type="datetime"]:not(.browser-default):focus:not([readonly])+label, .md-form input[type="datetime-local"]:not(.browser-default):focus:not([readonly])+label, .md-form input[type="tel"]:not(.browser-default):focus:not([readonly])+label, .md-form input[type="number"]:not(.browser-default):focus:not([readonly])+label, .md-form input[type="search"]:not(.browser-default):focus:not([readonly])+label, .md-form input[type="phone"]:not(.browser-default):focus:not([readonly])+label, .md-form input[type="search-md"]:focus:not([readonly])+label, .md-form textarea.md-textarea:focus:not([readonly])+label {
        color: #A52A2A;
    }

    @media (min-width: 576px) {

    }

    @media (min-width: 768px) {
        a {
            font-size: 18px;
        }
    }

    @media (min-width: 992px) {

    }

    @media (min-width: 1200px) {

    }

    @media (min-width: 1600px) {

    }


</style>
